import { useSetAtom } from 'jotai';
import { MouseEvent, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { atomInfoCampaignV1 } from '@/modules/CampaignsModule/atoms/campaignAtom';
import { atomToggleEditCreateCampaignModal } from '@/modules/CampaignsModule/atoms/modalsCampaignAtom';
import { useCampaignsMutationContext } from '@/modules/CampaignsModule/contexts/CampaignsContext';
import { ICampaign } from '@/modules/CampaignsModule/interfaces/Campaigns';

export const useHandleEvents = () => {
  const navigate = useNavigate();
  const setInfoCampaignV1 = useSetAtom(atomInfoCampaignV1);

  const setToggleEditCategoryModal = useSetAtom(atomToggleEditCreateCampaignModal);
  const { setClearFilterBy } = useCampaignsMutationContext();

  const handleClickEmptyScreen = useCallback(() => {
    setToggleEditCategoryModal(true);
  }, [setToggleEditCategoryModal]);

  const handleClickEmptyScreenNoResult = useCallback(() => {
    setClearFilterBy(true);
  }, [setClearFilterBy]);

  const handleClickReport = useCallback(
    (event: MouseEvent<HTMLButtonElement>, value: ICampaign) => {
      event.stopPropagation();
      navigate(`/v2/campaigns/${value.campaignId}/report`);
      setInfoCampaignV1({
        campaign: {
          id: Number(value?.campaignId),
          name: value?.name ?? '',
        },
      });
    },
    [navigate, setInfoCampaignV1]
  );

  return {
    handleClickReport,
    handleClickEmptyScreen,
    handleClickEmptyScreenNoResult,
  };
};
